import { render, staticRenderFns } from "./setPenetapanGaji.vue?vue&type=template&id=6cf56d85&"
import script from "./setPenetapanGaji.vue?vue&type=script&lang=js&"
export * from "./setPenetapanGaji.vue?vue&type=script&lang=js&"
import style0 from "./setPenetapanGaji.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports